import { CYCLE_YEAR } from '../../../config/recruitingCycle';

const applyingSummary = (
  <div className="perfect-application-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Where to Find Job Openings</h3>
      <ul className="list-disc pl-6">
        <li>
          <a
            href="https://www.linkedin.com/jobs/"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            LinkedIn Jobs tab
          </a>
        </li>
        <li>
          School job boards (e.g.,{' '}
          <a
            href="https://joinhandshake.com/"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Handshake
          </a>
          )
        </li>
        <li>
          <a
            href={`https://www.google.com/search?q=software+engineering+internships+${CYCLE_YEAR}`}
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Google search
          </a>
        </li>
        <li>
          Specialized job boards for software engineering (e.g.,{' '}
          <a
            href="https://www.intern-list.com/"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            InternList
          </a>
          )
        </li>
        <li>Company websites</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Resume Tips</h3>
      <ul className="list-disc pl-6">
        <li>Tailor your resume for each specific job</li>
        <li>Include keywords from the job description and highlight relevant skills</li>
        <li>Update regularly to reflect new skills and experiences</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Cover Letters</h3>
      <ul className="list-disc pl-6">
        <li>Similar to college application essays</li>
        <li>Explains why you're excited about the position and your background</li>
        <li>Not always required for tech jobs, but can help your application stand out</li>
        <li>
          Templates are available online (e.g.,{' '}
          <a
            href="https://www.indeed.com/career-advice/resumes-cover-letters/how-to-write-a-cover-letter"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Indeed's guide
          </a>
          )
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">What else should I include?</h3>
      <ul className="list-disc pl-6">
        <li>LinkedIn profile link</li>
        <li>GitHub profile link to showcase coding projects</li>
        <li>Personal website (if available)</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to track applications?</h3>
      <ul className="list-disc pl-6">
        <li>InternHub provides a module for tracking applications!</li>
      </ul>
    </div>
  </div>
);

export default applyingSummary;
